import React, { useMemo } from 'react'
import { ReactSVG } from 'react-svg'
import { useAccoladesQuery } from './hooks/use-accolades-query'
import { useCalloutQuery } from './hooks/use-callout-query'
import { useContactQuery } from './hooks/use-contact-query'
import { useDataPinsQuery } from './hooks/use-data-pins-query'
import { useFeaturedServicesQuery } from './hooks/use-featured-services-query'
import { useFooterQuery } from './hooks/use-footer-query'
import { useGeneralSchemaQuery } from './hooks/use-general-schema-query'
import { useHeaderQuery } from './hooks/use-header-query'
import { useHomeHeroQuery } from './hooks/use-home-hero-query'
import { useInteriorHeroDefaultQuery } from './hooks/use-interior-hero-default'
import { useLatestBlogsQuery } from './hooks/use-latest-blogs-query'
import { useMobileCtaQuery } from './hooks/use-mobile-cta-query'
import { useMultiStepFormQuery } from './hooks/use-multi-step-form-query'
import { useOurCouponsQuery } from './hooks/use-our-coupons-query'
import { useOurServicesMenuQuery } from './hooks/use-our-services-menu-query'
import { useOurServicesQuery } from './hooks/use-our-services-query'
import { useOurStoryQuery } from './hooks/use-our-story-query'
import { useOurWorkQuery } from './hooks/use-our-work-query'
import { usePageSpecificSchemaQuery } from './hooks/use-page-specific-schema-query'
import { usePostHeroDefaultQuery } from './hooks/use-post-hero-default-query'
import { useServiceAreasQuery } from './hooks/use-service-areas-query'
import { useTestimonialsQuery } from './hooks/use-testimonials-query'
import { useWhatWeOfferQuery } from './hooks/use-what-we-offer-query'
import favicon from './images/favicon.png'

export function GeneralSchemaFunction() {
  const { wp, site, query1, forRatingValuePart1, forRatingValuePart2 } = useGeneralSchemaQuery()

  const data = wp.nexvelSchemaMarkup.nexvelschema

  return {
    services: data.services,
    cities: data.cities,
    businessName: data.businessName,
    siteUrl: site.siteMetadata.siteUrl,
    businessType: data.businessType,
    logo: data.logo.localFile.publicURL,
    image: data.image.localFile.publicURL,
    businessDescription: data.describeYourBusiness,
    phoneNumber: data.phoneNumber,
    address: data.streetAddress,
    city: data.city,
    state: data.state,
    zip: data.zipCode,
    openSunday: data.hoursOfOperation.sunday.areYouOpen,
    sundayClosingTime: `${data.hoursOfOperation.sunday.close.closeHour}:${data.hoursOfOperation.sunday.close.closeMinute} ${data.hoursOfOperation.sunday.close.amorpm}`,
    sundayOpeningTime: `${data.hoursOfOperation.sunday.open.openHour}:${data.hoursOfOperation.sunday.open.openMinute} ${data.hoursOfOperation.sunday.open.amorpm}`,
    openMonday: data.hoursOfOperation.monday.areYouOpen,
    mondayClosingTime: `${data.hoursOfOperation.monday.close.closeHour}:${data.hoursOfOperation.monday.close.closeMinute} ${data.hoursOfOperation.monday.close.amorpm}`,
    mondayOpeningTime: `${data.hoursOfOperation.monday.open.openHour}:${data.hoursOfOperation.monday.open.openMinute} ${data.hoursOfOperation.monday.open.amorpm}`,
    openTuesday: data.hoursOfOperation.tuesday.areYouOpen,
    tuesdayClosingTime: `${data.hoursOfOperation.tuesday.close.closeHour}:${data.hoursOfOperation.tuesday.close.closeMinute} ${data.hoursOfOperation.tuesday.close.amorpm}`,
    tuesdayOpeningTime: `${data.hoursOfOperation.tuesday.open.openHour}:${data.hoursOfOperation.tuesday.open.openMinute} ${data.hoursOfOperation.tuesday.open.amorpm}`,
    openWednesday: data.hoursOfOperation.wednesday.areYouOpen,
    wednesdayClosingTime: `${data.hoursOfOperation.wednesday.close.closeHour}:${data.hoursOfOperation.wednesday.close.closeMinute} ${data.hoursOfOperation.wednesday.close.amorpm}`,
    wednesdayOpeningTime: `${data.hoursOfOperation.wednesday.open.openHour}:${data.hoursOfOperation.wednesday.open.openMinute} ${data.hoursOfOperation.wednesday.open.amorpm}`,
    openThursday: data.hoursOfOperation.thursday.areYouOpen,
    thursdayClosingTime: `${data.hoursOfOperation.thursday.close.closeHour}:${data.hoursOfOperation.thursday.close.closeMinute} ${data.hoursOfOperation.thursday.close.amorpm}`,
    thursdayOpeningTime: `${data.hoursOfOperation.thursday.open.openHour}:${data.hoursOfOperation.thursday.open.openMinute} ${data.hoursOfOperation.thursday.open.amorpm}`,
    openFriday: data.hoursOfOperation.friday.areYouOpen,
    fridayClosingTime: `${data.hoursOfOperation.friday.close.closeHour}:${data.hoursOfOperation.friday.close.closeMinute} ${data.hoursOfOperation.friday.close.amorpm}`,
    fridayOpeningTime: `${data.hoursOfOperation.friday.open.openHour}:${data.hoursOfOperation.friday.open.openMinute} ${data.hoursOfOperation.friday.open.amorpm}`,
    openSaturday: data.hoursOfOperation.saturday.areYouOpen,
    saturdayClosingTime: `${data.hoursOfOperation.saturday.close.closeHour}:${data.hoursOfOperation.saturday.close.closeMinute} ${data.hoursOfOperation.saturday.close.amorpm}`,
    saturdayOpeningTime: `${data.hoursOfOperation.saturday.open.openHour}:${data.hoursOfOperation.saturday.open.openMinute} ${data.hoursOfOperation.saturday.open.amorpm}`,
    reviewsForRatingValuePart1:
      forRatingValuePart1?.nodes.length &&
      forRatingValuePart1.nodes.map((rating, i) => {
        return {
          index: i,
          rating: rating.rating,
        }
      }),
    reviewsForRatingValuePart2:
      forRatingValuePart2?.nodes.length &&
      forRatingValuePart2.nodes.map((rating, i) => {
        return {
          index: i,
          rating: rating.rating,
        }
      }),
    reviewsQuery:
      query1?.nodes.length &&
      query1.nodes.map((review, i) => {
        return {
          index: i,
          id: review.id,
          sourceType: review.sourceType,
          reviewDate: review.reviewDate,
          rating: review.rating,
          reviewerFirstName: review.reviewer.firstName,
          reviewerLastName: review.reviewer.lastName,
          comments: review.comments,
          businessName: review.businessName,
        }
      }),
    offers: data.offersSchema?.map(offer => {
      return {
        offer: offer.offerSchema,
        url: offer.urlSchema,
      }
    }),
    awards: data.awardsSchema?.map(award => {
      return {
        award: award.awardSchema,
      }
    }),
    brands: data.brandsSchema?.map(brand => {
      return {
        brand: brand.brandSchema,
      }
    }),
    certifications: data.certificationsSchema?.map(certification => {
      return {
        certification: certification.certificationSchema,
      }
    }),
    languages: data.languagesSchema?.map(language => {
      return {
        language: language.languageSchema,
      }
    }),
    organizations: data.organizationsSchema?.map(organization => {
      return {
        organization: organization.organizationSchema,
      }
    }),
    socialProfilesDirectoryListings: data.socialMediaProfilesAndDirectoryListingsSchema?.map(
      item => {
        return {
          socialProfileDirectory: item.socialMediaProfileOrDirectoryListingSchema,
        }
      },
    ),
  }
}
export function SeoFunction(data) {
  const seoData = data.wpPage !== undefined ? data.wpPage : data.wpPost
  return {
    page:
      // eslint-disable-next-line no-nested-ternary
      data.wpPost !== undefined
        ? 'blogPost'
        : data.sitePage?.path === '/blog/'
          ? 'blogIndexPage'
          : null,
    favicon,
    title: seoData?.seo.title,
    metaDescription: seoData?.seo.metaDesc,
    ogTitle: seoData?.seo.opengraphTitle,
    ogDescription: seoData?.seo.opengraphDescription,
    ogUrl: seoData?.seo.opengraphUrl,
    ogSiteName: seoData?.seo.opengraphSiteName,
    ogType: seoData?.seo.opengraphType,
    ogImage: seoData?.seo.opengraphImage?.localFile.publicURL,
    canonicalUrl: seoData?.seo.canonical,
    twitterTitle: seoData?.seo.twitterTitle,
    twitterDescription: seoData?.seo.twitterDescription,
    twitterImage: seoData?.seo.twitterImage?.localFile.childImageSharp.gatsbyImageData,
  }
}
export function PageSpecificSchemaFunction(data) {
  const pageData = data.wpPage !== undefined ? data.wpPage : data.wpPost
  const pageSpecificSchemaData = usePageSpecificSchemaQuery().wp

  return {
    businessName: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.businessName,
    businessType: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.businessType,
    phoneNumber: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.phoneNumber,
    streetAddress: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.streetAddress,
    city: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.city,
    state: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.state,
    zipCode: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.zipCode,
    logo: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.logo.localFile.publicURL,
    blogPageUrl: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.blogPageUrl,
    aboutPageUrl: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.aboutPageUrl,
    contactPageUrl: pageSpecificSchemaData.nexvelSchemaMarkup.nexvelschema.contactPageUrl,
    siteUrl: data.site.siteMetadata.siteUrl,
    uri: pageData !== undefined ? pageData.uri : '/blog/',
    title: pageData !== undefined ? pageData.title : 'Blog',
    datePublished: pageData?.date,
    dateModified: pageData?.modified,
    image:
      pageData?.seo?.opengraphImage !== null
        ? // eslint-disable-next-line no-unsafe-optional-chaining
          data.site.siteMetadata.siteUrl + pageData?.seo?.opengraphImage.localFile.publicURL
        : '/blank.jpg',
    author: `${pageData?.author?.node.firstName} ${pageData?.author?.node.lastName}`,
    categories:
      pageData?.categories?.nodes.length &&
      pageData?.categories.nodes.map((category, i) => {
        return {
          index: i,
          name: category.name,
        }
      }),
    tags:
      pageData?.tags?.nodes.length &&
      pageData?.tags.nodes.map((tag, i) => {
        return {
          index: i,
          name: tag.name,
        }
      }),
    articleBody: pageData?.content,
    post: data.wpPost !== undefined,
    videos:
      pageData?.nexvelschemapagesposts?.videos?.length &&
      pageData?.nexvelschemapagesposts?.videos.map((video, i) => {
        return {
          index: i,
          title: video.title,
          url: video.url,
          description: video.description,
          thumbnailImage: video.thumbnailImage.localFile.publicURL,
          uploadDate: video.uploadDate,
        }
      }),
    questionsAndAnswers:
      pageData?.nexvelschemapagesposts?.questionsAndAnswers?.length &&
      pageData?.nexvelschemapagesposts?.questionsAndAnswers.map((qanda, i) => {
        return {
          index: i,
          question: qanda.question,
          answer: qanda.answer,
        }
      }),
    maps:
      pageData?.nexvelschemapagesposts?.maps?.length &&
      pageData?.nexvelschemapagesposts?.maps.map((map, i) => {
        return {
          index: i,
          url: map.mapUrl,
        }
      }),
    digitalDocuments:
      pageData?.nexvelschemapagesposts?.digitaldocuments?.length &&
      pageData?.nexvelschemapagesposts?.digitaldocuments.map((document, i) => {
        return {
          index: i,
          title: document.title,
        }
      }),
    images:
      pageData?.nexvelschemapagesposts?.images?.length &&
      pageData?.nexvelschemapagesposts?.images.map((item, i) => {
        return {
          index: i,
          image: item.image.localFile.publicURL,
          date: item.image.date,
          description: item.image.description,
          title: item.image.title,
        }
      }),
    areaServedGeneral: data.wp.nexvelSchemaMarkup?.nexvelschema.cities.map(city => {
      return {
        city: city.city,
      }
    }),
    areaServedPageSpecific: pageData?.nexvelschemapagesposts?.areaServedLandingPageSchema,
    serviceGeneral: data.wp.nexvelSchemaMarkup?.nexvelschema.services.map(service => {
      return {
        serviceName: service.service,
        relevantPage: service.linkToRelevantPageOnYourWebsite,
      }
    }),
    servicePageSpecific: {
      serviceName: pageData?.nexvelschemapagesposts?.serviceSchema.serviceNameSchema,
      relevantPage: pageData?.nexvelschemapagesposts?.serviceSchema.linkToRelevantServicePageSchema,
    },
    keywords: pageData?.nexvelschemapagesposts?.keywordsSchema?.map(item => {
      return {
        keyword: item.keywordSchema,
      }
    }),
    localAwards: pageData?.nexvelschemapagesposts?.localAwardsSchema?.map(item => {
      return {
        localAward: item.localAwardSchema,
      }
    }),
    latitude: pageData?.nexvelschemapagesposts?.latitudeSchema,
    longitude: pageData?.nexvelschemapagesposts?.longitudeSchema,
    relevantExternalPages: pageData?.nexvelschemapagesposts?.relevantExternalPagesSchema?.map(
      item => {
        return {
          relevantExternalPage: item.relevantExternalPageSchema,
        }
      },
    ),
  }
}

export function MultiStepFormFunction() {
  const { wp } = useMultiStepFormQuery()
  const form = wp.acfOptionsMultiStepForm.multiStepForm
  return {
    logo: {
      src: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
      alt: 'logo',
      width: 275,
      height: 67,
    },
    stepTitles: form.stepTitles.map(stepTitle => {
      return {
        title: stepTitle.stepTitle,
      }
    }),
    van: {
      src: form.vanImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      alt: form.vanImageAltText,
      width: form.vanImage.localFile.childImageSharp.gatsbyImageData.width,
      height: form.vanImage.localFile.childImageSharp.gatsbyImageData.height,
    },
    issues: form.issues.map(issue => {
      return {
        issue: issue.issue,
        subIssues: issue.subIssues,
      }
    }),
    moreInfo: form.moreInfo,
    photoText: form.photoText,
    maxUploadText: form.maxUploadText,
    timeSlotTitle: form.timeSlotTitle,
    timeSlots: form.timeSlots.map(timeSlot => {
      return {
        timeSlot: timeSlot.timeSlot,
      }
    }),
    appointmentText: form.appointmentText,
    ourPhoneNumber: wp.acfOptionsCommonItems.commonItems.phoneNumber,
    confirmationText: form.confirmationText,
    formSubmittedText: form.formSubmittedText,
    formAction: '/.netlify/functions/form-submission',
    bgColor: 'bg-blue-dark3',
    innerBgColor: 'bg-white',
    borderColor: 'border-gray-darker3',
    inputBorderColor: '[&>input]:border-gray-darker3',
    inputTextColor: '[&>input]:text-gray-darker3 [&>input]:mt-2',
    placeholderTextColor: '[&>input]:placeholder:text-gray-darker3',
    continueButtonDisabled: 'text-gray fill-gray',
    continueButton: 'text-gray-darker3 fill-gray-darker3',
    continueButtonBorder: 'border-gray-darker3',
    continueButtonBorderDisabled: 'border-gray',
    stepsColor: 'text-white',
    stepsBgColor: 'bg-orange',
    stepMarkerColorActive: 'bg-white',
    stepMarkerColor: 'bg-gray',
    selectArrow: 'bg-orange',
    selectArrowDisabled: 'bg-gray',
    timeSlotColor: 'bg-blue-dark3',
    timeSlotInactiveColor: 'bg-orange',
    selectColor: 'text-gray-darker3',
    paragraphColor: 'text-gray-darker3',
    uploadBgColor: 'bg-white',
    arrowColor: 'bg-white',
    whatConvertsFormId: 95921,
    useCaptcha: true,
    captchaSiteKey: '6LedlioqAAAAAPGxurLr-mgnl9daVz7EWWKitB_T',
  }
}

export function HeaderFunction(handleButton, blog) {
  const {
    wp,
    mainMenuDropdownImages,
    mainMenu,
    topBarMenu,
    forRatingValuePart1,
    forRatingValuePart2,
  } = useHeaderQuery()
  function dropdownImg(a, b) {
    if (b.filter(e => e.associatedDropdown === a).length > 0) {
      const image2 = b.filter(e => e.associatedDropdown === a)

      return image2
    }
    return false
  }

  const menuImages = mainMenuDropdownImages.mainMenuImages.imageContainer.map(image => {
    return {
      src: image.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      srcSet: `${image.image.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
      width: image.image.localFile.childImageSharp.gatsbyImageData.width,
      height: image.image.localFile.childImageSharp.gatsbyImageData.height,
      alt: image.altText,
      associatedDropdown: image.whichMenuItemIsThisAssociatedWith,
    }
  })

  function length(obj) {
    return Object.keys(obj).length
  }

  const averageRating = useMemo(() => {
    const reviewsRatings = {
      reviewsForRatingValuePart1:
        forRatingValuePart1?.nodes.length &&
        forRatingValuePart1.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
      reviewsForRatingValuePart2:
        forRatingValuePart2?.nodes.length &&
        forRatingValuePart2.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
    }

    const fiveFourThreeRatings = length(reviewsRatings.reviewsForRatingValuePart2)

    const totalRatings = length(reviewsRatings.reviewsForRatingValuePart1)

    const ratingsTotal = reviewsRatings.reviewsForRatingValuePart1

    const total = ratingsTotal.reduce((sum, item) => sum + item.rating, 0)

    let avgRating = total / fiveFourThreeRatings
    avgRating = avgRating.toFixed(1)

    return [avgRating, totalRatings]
  }, [forRatingValuePart1, forRatingValuePart2])

  return {
    menuData: mainMenu.nodes.map(topLevel => {
      return {
        label: topLevel.label,
        link: topLevel.path,
        image: dropdownImg(topLevel.label, menuImages)[0]?.src,
        srcSet: dropdownImg(topLevel.label, menuImages)[0]?.srcSet,
        width: dropdownImg(topLevel.label, menuImages)[0]?.width,
        height: dropdownImg(topLevel.label, menuImages)[0]?.height,
        subMenu: topLevel.childItems.nodes.length
          ? topLevel.childItems.nodes.map(secondLevel => {
              return {
                label: secondLevel.label,
                link: secondLevel.path,
                subMenu: secondLevel.childItems.nodes.length
                  ? secondLevel.childItems.nodes.map(thirdLevel => {
                      return {
                        label: thirdLevel.label,
                        link: thirdLevel.path,
                        subMenu: [],
                      }
                    })
                  : [],
              }
            })
          : [],
      }
    }),
    topBgColor: 'bg-white',
    upperTextColor: 'text-blue-gray2',
    rate: averageRating[0],
    starPrimary: '#F79423',
    starSecondary: '#dddddd',
    reviewCnt: averageRating[1],
    reviewsLabel: wp.acfOptionsCommonItems.commonItems.reviewLabel,
    reviewLink: wp.acfOptionsCommonItems.commonItems.reviewsLink.url,
    topMenuBorder: 'text-blue-gray2',
    topMenuData: topBarMenu.nodes.map(topBar => {
      return {
        label: topBar.label,
        link: topBar.path,
      }
    }),
    bgColor: 'bg-transparent',
    mobileBgColor: 'bg-blue',
    hamburgerColor: '#ffffff',
    menuItemActiveTextColor: 'text-white',
    megaMenuRequestButtonBorderColor: 'border-orange',
    menuLabel: wp.acfOptionsCommonItems.commonItems.menuLabel,
    menuLabelColor: 'text-white',
    button: {
      label: wp.acfOptionsCommonItems.commonItems.menuButton1,
      notLink: true,
      borderColor: 'border-yellow',
      fontWeight: 'font-bold',
      fontSize: 'text-[15px] !px-0',
      textColor: 'text-blue',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue',
      onClick: handleButton,
      icon: false,
      twoLabels: false,
    },
    button2: {
      label: wp.acfOptionsCommonItems.commonItems.menuButton2.title,
      notLink: false,
      borderColor: 'border-blue',
      fontWeight: 'font-medium',
      fontSize: 'text-[15px]',
      textColor: 'text-white',
      bgColor: 'bg-blue',
      hoverBgColor: 'hover:bg-blue-light',
      hoverBorderColor: 'hover:border-blue-light',
      href: wp.acfOptionsCommonItems.commonItems.menuButton2.url,
      icon: false,
      twoLabels: false,
    },
    phoneNumber: wp.acfOptionsCommonItems.commonItems.phoneNumber,
    onRequestServiceClick: handleButton,
    megaMenuAltText: mainMenuDropdownImages.mainMenuImages.altText,
    megaMenuBgColor: 'bg-orange-dark',
    megaMenuTextColor: 'text-white',
    megaMenuMenuActiveBgColor: 'bg-orange-light',
    megaMenuMenuDividerBorderBottomColor: 'border-white',
    megaMenuSubMenuActiveBgColor: 'bg-orange-light hover:bg-blue',
    megaMenuSubMenuDividerBorderBottomColor: 'border-white',
    logo: wp.acfOptionsCommonItems.commonItems.navLogo.localFile.publicURL,
    callButtonProps: {
      label: `PA: ${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      notLink: false,
      fontSize: 'text-lg',
      textColor: 'text-blue-dark2',
      borderColor: 'border-yellow',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue-dark2',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      icon: true,
      iconColor: '#0D3045',
      phoneOrCalender: 'phone',
    },
    callButtonProps2: {
      label: `NJ: ${wp.acfOptionsCommonItems.commonItems.phoneNumberNj}`,
      notLink: false,
      fontSize: 'text-[0.9375rem] xxl:text-[1.250rem]',
      textColor: 'text-white',
      borderColor: 'border-orange',
      bgColor: 'bg-orange',
      hoverBgColor: 'hover:bg-orange-lighter',
      hoverBorderColor: 'hover:border-orange-lighter',
      hoverTextColor: 'hover:text-white',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumberNj}`,
      icon: true,
      iconColor: '#ffffff',
      phoneOrCalender: 'phone',
    },
    mobileCallButton: {
      label: 'Call PA',
      notLink: false,
      fontSize: 'text-[14px] leading-none !py-2 !font-bold !font-body',
      textColor: 'text-blue-dark2',
      borderColor: 'border-yellow',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue-dark2',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      icon: true,
      iconColor: '#0D3045',
      phoneOrCalender: 'phone',
    },
    mobileCallButton2: {
      label: 'Call NJ',
      notLink: false,
      fontSize: 'text-[14px] leading-none !py-2 !font-bold !font-body',
      textColor: 'text-white',
      borderColor: 'border-orange',
      bgColor: 'bg-orange',
      hoverBgColor: 'hover:bg-orange-lighter',
      hoverBorderColor: 'hover:border-orange-lighter',
      hoverTextColor: 'hover:text-white',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumberNj}`,
      icon: true,
      iconColor: '#ffffff',
      phoneOrCalender: 'phone',
    },
    logoImg: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
    logoSrcSet: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
    width: '100%',
    logoWidthMobile: '200px',
    mobileSubBgColor: 'bg-orange',
    mobileFontWeight: 'font-bold',
    mobileSubFontWeight: 'font-normal',
    mobileTextColor: 'text-white',
    mobileHeaderBgColor: 'bg-blue',
    mobileCloseTextColor: 'text-white',
    mobileDividerBorderColor: 'border-white',
    mobileRequestButtonLabel: 'Request Service',
    mobileRequestButtonTextColor: 'text-white !font-bold',
    mobileRequestButtonAfterBgColor: 'bg-blue-darkest',
    mobileRequestButtonBorderColor: 'border-blue-darkest',
    mobileBreadCrumbHomeLabel: 'Home',
    mobileBreadCrumbDivider: '/',
    mobileBreadCrumbTextColor: 'text-white',
    mobileActive: 'active:bg-gray-light',
    subMenuTextColor: 'text-white',
    button3: {
      notLink: false,
      borderColor: 'border-yellow',
      bgColor: 'bg-yellow !h-[64px] !w-[64px]',
      fontSize: '!py-0 !px-0',
      hoverBgColor: 'hover:bg-yellow',
      hoverBorderColor: 'hover:border-yellow',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      icon: true,
      iconColor: '#ffffff',
      phoneOrCalender: 'phone',
    },
    isBlog: blog,
    blogBgColor: 'bg-blue-dark3',
    financingLink: wp.acfOptionsCommonItems.commonItems.financingLink.url,
    financingText: wp.acfOptionsCommonItems.commonItems.financingLink.title,
    financingColor: 'text-orange',
  }
}

export function InteriorHeroFunction(data, handleButton) {
  const commonItems = useInteriorHeroDefaultQuery()
  return {
    bgImage:
      data.wpPage.featuredImage !== null
        ? data.wpPage.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback
            .src
        : commonItems.interiorPage.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images
            .fallback.src,
    bgGradient: 'bg-gradient-to-r from-[#0B171A] lg:via-transparent to-transparent',
    title: data.wpPage.interiorHero.title,
    subtitle: data.wpPage.interiorHero.subtitle,
    buttonProps: {
      label: commonItems.interiorPage.buttonText,
      notLink: true,
      borderColor: 'border-yellow',
      fontWeight: 'font-[900]',
      fontSize: 'text-[17px]',
      textColor: 'text-blue-dark2',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue-dark2',
      onClick: handleButton,
      icon: false,
    },
    textColor: 'text-white',
    heroBadge: commonItems.heroBadge.localFile.publicURL,
    heroBadgeWidth: '370px',
    heroBadgeWidthMobile: '350px',
  }
}

export function LatestBlogsFunction() {
  const { wpPage, allWpPost, wp } = useLatestBlogsQuery()
  return {
    recentBlogList: allWpPost.nodes.map(post => {
      return {
        image:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.src
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp
                .gatsbyImageData.images.fallback.src,
        srcSet:
          post.featuredImage !== null
            ? `${post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`
            : `${wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
        width:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.width
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp
                .gatsbyImageData.width,
        height:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.height
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp
                .gatsbyImageData.height,
        alt:
          post.featuredImage !== null
            ? post.postFeaturedImageAltText.altText
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefaultAltText,
        createdAt: post.date,
        title: post.title,
        description: post.excerpt,
        link: `/blog${post.link}`,
      }
    }),
    title: wpPage.latestBlogs.latestBlogs.title,
    titleColor: 'text-blue-dark',
    blogCardStyles: {
      dateColor: 'text-orange',
      titleColor: 'text-blue-dark2',
      bgColor: 'bg-white',
      textColor: 'text-blue-dark2',
    },
    bgImage:
      wpPage.latestBlogs.latestBlogs.backgroundImage.localFile.childImageSharp.gatsbyImageData
        .images.fallback.src,
    bgColor: 'bg-white',
  }
}

export function ServiceAreasFunction() {
  const data = useServiceAreasQuery()
  return {
    serviceAreas: data.states.map(state => {
      return {
        serviceAreasState: state.stateName,
        services: state.services.map(service => {
          return {
            serviceName: service.serviceName,
            serviceAreasCounties: service.counties.map(county => {
              return {
                serviceAreasCountyName: county.countyName,
                map: county.mapImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
                mapAltText: county.mapImageAltText,
                mapWidth: '100%',
                serviceAreasTowns: county.townLinks,
              }
            }),
          }
        }),
      }
    }),
    panelBgColor: 'bg-[#F9F9F9] lg:bg-white',
    interiorPanelBgColor: 'bg-[#F9F9F9]',
    countyActiveBgColor: 'bg-orange',
    countyInactiveBgColor: 'bg-white',
    countyHoverBgColor: 'hover:bg-orange',
    innerBackgroundColor: 'bg-transparent',
    innerTextColor: '!text-blue-dark2',
    textColor2: 'text-blue-dark2',
    mobileBackgroundColor: 'bg-transparent',
    desktopBackgroundColor: 'lg:bg-transparent',
    activeTextColor: 'text-white',
    activeFill: 'fill-white',
    inactiveFill: 'fill-gray-darker2',
    bgImage: data.backgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title,
    textColor: 'text-blue-dark2',
    overlayImage: data.imageOverlay.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    overlayAltText: data.imageOverlayAltText,
    bgColor: 'bg-[#e8ebef]',
    mobileBgImage:
      data.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    triangleColor: 'border-b-orange',
    countyHoverTextColor: 'hover:!text-white',
    countyHoverFill: 'hover:fill-white',
    countyTabBgColor: 'bg-white lg:bg-[#F9F9F9]',
    countyTabTextColor: 'text-blue-dark2',
    activeCountyTabBgColor: 'bg-[#EDF0F1]',
    serviceBorderColor: 'border-orange',
  }
}

export function BackToTopFunction() {
  return {
    text: 'Back to Top',
    textColor: 'text-blue-dark7',
    arrowColor: '[&_path]:stroke-gray-darker2',
  }
}
export function FooterFunction() {
  const { wp, footerMenu1, footerMenu2 } = useFooterQuery()
  const { footer } = wp.acfOptionsCommonItems.commonItems
  return {
    bgColor: 'bg-blue-dark7',
    logo: <ReactSVG src={wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL} />,
    socialMedia: footer.socialMedia.map(social => {
      return {
        logo: <ReactSVG src={social.socialMediaIcon.localFile.publicURL} />,
        link: social.socialMediaLink.url,
      }
    }),
    menu1Title: footerMenu1.nodes[0].menu.node.name,
    menu1: footerMenu1.nodes.map(menuItem => {
      return {
        label: menuItem.label,
        path: menuItem.path,
      }
    }),
    menu2Title: footerMenu2.nodes[0].menu.node.name,
    menu2: footerMenu2.nodes.map(menuItem => {
      return {
        label: menuItem.label,
        path: menuItem.path,
      }
    }),
    contactLabel: footer.contactLabel,
    locations: footer.locations.map(location => {
      return {
        label: location.label,
        address: location.address,
        phoneText: location.phoneText,
      }
    }),
    phoneNumber: wp.acfOptionsCommonItems.commonItems.phoneNumber,
    phoneNumberNj: wp.acfOptionsCommonItems.commonItems.phoneNumberNj,
    officeHoursLabel: footer.officeHoursLabel,
    officeHours: footer.officeHours,
    affiliations: footer.affiliations.map(affiliate => {
      return {
        logo: <ReactSVG src={affiliate.logo.localFile.publicURL} />,
      }
    }),
    copyright: footer.copyright,
    nexvel: {
      logo: {
        src: footer.nexvelLogo.localFile.publicURL,
        alt: footer.nexvelLogoAltText,
        width: 177,
        height: 61,
      },
      link: footer.nexvelLink.url,
    },
    headingColor: 'text-white',
    textColor: 'text-gray-darker',
    borderTopColor: 'border-gray-darker',
  }
}
export function ContactFunction() {
  const { wp, wpPage } = useContactQuery()
  const data = wpPage.contact.contact
  return {
    bgColor: 'bg-orange-dark3',
    textColor: 'text-white [&_input]:text-black [&_textarea]:text-black',
    bgImg: data.backgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title,
    text: data.text,
    recaptchaKey: '6LedlioqAAAAAPGxurLr-mgnl9daVz7EWWKitB_T',
    submitButton: {
      label: data.submitButtonText,
      notLink: true,
      borderColor: 'border-transparent',
      fontWeight: 'font-[900]',
      fontSize: 'font-[17px]',
      textColor: 'text-blue-dark2',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-blue-dark2',
      hoverBorderColor: 'hover:border-transparent',
      hoverTextColor: 'hover:text-white',
      icon: false,
      twoLabels: false,
    },
    foregroundImg: {
      src: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      width: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.height,
      alt: data.foregroundImageAltText,
    },
    callButton: {
      label: `${wp.acfOptionsCommonItems.commonItems.callText} ${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      notLink: false,
      fontSize: 'text-lg',
      textColor: 'text-white',
      borderColor: 'border-transparent',
      bgColor: 'bg-transparent',
      hoverBgColor: 'hover:bg-transparent',
      hoverBorderColor: 'hover:border-transparent',
      hoverTextColor: 'hover:text-blue-dark2',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      icon: true,
      iconColor: '#ffffff',
    },
    actionUrl: '/thank-you/',
    placeholderColor: '[&>input]:placeholder:text-blue-dark2 placeholder:text-blue-dark2',
  }
}
export function FeaturedServicesFunction() {
  const data = useFeaturedServicesQuery()
  return {
    title: data.title,
    subtitle: data.subtitle,
    text: data.text,
    accordions: data.accordions.map(accordion => {
      return {
        icon: <ReactSVG src={accordion.icon.localFile.publicURL} />,
        label: accordion.label,
        image: {
          src: accordion.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
          alt: accordion.altText,
          width: accordion.image.localFile.childImageSharp.gatsbyImageData.width,
          height: accordion.image.localFile.childImageSharp.gatsbyImageData.height,
        },
        title: accordion.title,
        text: accordion.text,
        link: {
          label: accordion.link.title,
          notLink: false,
          borderColor: 'border-orange-light',
          fontWeight: 'font-[900]',
          fontSize: 'text-[17px]',
          textColor: 'text-white',
          bgColor: 'bg-orange-light',
          hoverBgColor: 'hover:bg-orange-dark',
          hoverBorderColor: 'hover:border-orange-dark',
          hoverTextColor: 'hover:text-white',
          href: accordion.link.url,
          icon: false,
        },
      }
    }),
    bgColor: 'bg-gray-lighter',
    titleColor: 'text-yellow',
    textColor: 'text-blue-dark3',
    triangleColor: 'border-b-blue-dark3',
    cardBgColorOpen: 'bg-blue-dark3',
    fontColorOpen: 'text-white',
    iconColorOpen: '[&_path]:fill-white',
    buttonColor: 'bg-white',
    desktopBorderColor: 'border-blue-dark5/10',
    desktopActive: 'bg-white border-orange-dark/100',
    desktopHover: 'hover:bg-white hover:border-orange-dark',
  }
}
export function CalloutFunction(handleButton) {
  const data = useCalloutQuery()
  return {
    truck: {
      src: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      alt: data.foregroundAltText,
      width: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.width,
      height: data.foregroundImage.localFile.childImageSharp.gatsbyImageData.height,
    },
    bgImg: data.backgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    title: data.title,
    text: data.subtitle,
    button: {
      label: data.calloutButtonText,
      notLink: true,
      borderColor: 'border-blue',
      fontSize: 'text-lg',
      textColor: 'text-white',
      bgColor: 'bg-blue',
      hoverBgColor: 'hover:bg-yellow-light',
      hoverBorderColor: 'hover:border-yellow-light',
      hoverTextColor: 'hover:text-blue',
      onClick: handleButton,
      icon: false,
    },
    bgColor: 'bg-orange-dark',
    textColor: '!text-white',
  }
}
export function ServicesMenuFunction() {
  const data = useOurServicesMenuQuery()
  return {
    menuItems: data.nodes.map(menuItem => {
      return {
        icon: <ReactSVG src={menuItem.menuIcons.icon.localFile.publicURL} />,
        label: menuItem.label,
        path: menuItem.path,
        childItems: menuItem.childItems !== null && {
          nodes: menuItem.childItems.nodes.map(childItem => {
            return {
              label: childItem.label,
              path: childItem.path,
              icon: (
                <ReactSVG
                  src={childItem.menuIcons.icon.localFile.publicURL}
                  beforeInjection={svg => {
                    svg.setAttribute('style', 'width: 36px')
                  }}
                />
              ),
            }
          }),
        },
      }
    }),
    menuItemColor: 'text-blue-dark3 bg-gray',
    menuItemColorActiveSection: 'text-blue-dark3',
    menuItemColorActiveSectionBackground: 'bg-blue',
    menuItemColorActive: 'text-white',
    borderColor: 'border-gray',
    bgColorTopLevel: 'bg-tan',
    bgColorSecondLevel: 'bg-tan',
    hoverStates: 'hover:bg-blue active:bg-blue hover:text-white active:text-white',
    svgStyles: '[&_path]:fill-blue-dark3 [&_path]:hover:fill-white ',
    svgActive: `[&_path]:fill-white`,
  }
}
export function BlogPostFunction(data) {
  const defaultImg = usePostHeroDefaultQuery()
  return {
    image: {
      src:
        data.wpPost.featuredImage !== null
          ? data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback
              .src
          : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback
              .src,
      srcSet:
        data.wpPost.featuredImage !== null
          ? `${data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`
          : `${defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
      width:
        data.wpPost.featuredImage !== null
          ? data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.width
          : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.width,
      height:
        data.wpPost.featuredImage !== null
          ? data.wpPost.featuredImage.node.localFile.childImageSharp.gatsbyImageData.height
          : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.height,
      alt:
        data.wpPost.featuredImage !== null && data.wpPost.postFeaturedImageAltText !== undefined
          ? data.wpPost.postFeaturedImageAltText.altText
          : defaultImg.heroImageDefaultAltText,
    },
    blogTitle: data.wpPost.title,
    content: data.wpPost.content,
    prevButtonTitle: 'BACK TO PREV',
    nextButtonTitle: 'NEXT POST',
    outerBgColor: 'bg-white',
  }
}
export function InteriorContent1(data) {
  return {
    contentSection: data.wpPage.contentSection1.contentSection1,
  }
}
export function InteriorContent2(data) {
  return {
    contentSection: data.wpPage.contentSection2.contentSection2,
  }
}
export function FaqFunction(data) {
  return {
    heading: 'Frequently Asked Questions',
    questions: data.wpPage.nexvelschemapagesposts.questionsAndAnswers?.map(faq => {
      return {
        title: faq.question,
        content: faq.answer,
      }
    }),
    titleColor: 'text-[#0E3146]',
    tabBgColor: 'bg-transparent',
    tabBorderColor: 'border-[#E9E9E9]',
    borderBottomColor: 'border-b-[#CFCFCF]',
    contentColor: 'text-[#0E3146]',
    iconColor: 'text-[#0E3146]',
  }
}
export function InteriorCouponsFunction() {
  const { wpPage, wp } = useOurCouponsQuery()
  return {
    isHome: false,
    coupons: wpPage.ourCoupons.coupons.coupons.map(coupon => {
      return {
        couponDescription: coupon.text,
        percentageOrFixedAmount: coupon.percentOrFixedAmount,
        amountOff: coupon.amount,
        showOff: coupon.showOff,
      }
    }),
    couponProps: {
      logo: {
        src: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
        srcSet: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
      },
      bgColor: 'bg-blue',
      textColorTop: 'text-yellow',
      textColorBottom: 'text-white',
      printText: wpPage.ourCoupons.coupons.printButtonText,
      disclaimer: wpPage.ourCoupons.coupons.couponDisclaimer,
      offColor: 'text-white',
      priceBorder: 'border-white',
      priceBgColor: 'bg-orange',
      showOff: 'true',
      fillColor: 'fill-white',
      printColor: 'text-white',
      bgColorSecondary: 'bg-orange',
      textColorTopSecondary: 'text-white',
      priceBgColorSecondary: 'bg-blue',
      printColorSecondary: 'text-blue',
    },
    buttonPropsInterior: {
      label: wpPage.ourCoupons.coupons.linkTextInterior,
      notLink: false,
      borderColor: 'border-[#E1E1E1]',
      fontWeight: 'font-[900]',
      fontSize: 'text-[17px]',
      textColor: 'text-blue-dark2',
      bgColor: 'bg-[#E1E1E1]',
      hoverBgColor: 'hover:bg-[#E1E1E1]',
      hoverBorderColor: 'hover:border-[#E1E1E1]',
      hoverTextColor: 'hover:text-blue-dark2',
      href: wpPage.ourCoupons.coupons.linkUrl,
      icon: false,
    },
  }
}
export function BlogSliderFunction() {
  const { allWpPost, wp } = useLatestBlogsQuery()
  return {
    blogs: allWpPost.nodes.map(post => {
      return {
        image:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.src
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp
                .gatsbyImageData.images.fallback.src,
        srcSet:
          post.featuredImage !== null
            ? `${post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`
            : `${wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
        width:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.width
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp
                .gatsbyImageData.width,
        height:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.height
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefault.localFile.childImageSharp
                .gatsbyImageData.height,
        alt:
          post.featuredImage !== null
            ? post.postFeaturedImageAltText.altText
            : wp.acfOptionsCommonItems.commonItems.post.heroImageDefaultAltText,
        createdAt: post.date,
        title: post.title,
        description: post.excerpt,
        link: `/blog${post.link}`,
      }
    }),
    blogProps: {
      dateColor: 'text-orange',
      titleColor: 'text-blue-dark2',
      bgColor: 'bg-[#fafafa]',
      textColor: 'text-blue-dark2',
    },
  }
}
export function BlogOverviewFunction(data) {
  const defaultImg = usePostHeroDefaultQuery()
  return {
    blogList: data.allWpPost.nodes.map(post => {
      return {
        image:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.src
            : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback
                .src,
        srcSet:
          post.featuredImage !== null
            ? `${post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`
            : `${defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet}`,
        width:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.width
            : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.width,
        height:
          post.featuredImage !== null
            ? post.featuredImage.node.localFile.childImageSharp.gatsbyImageData.height
            : defaultImg.heroImageDefault.localFile.childImageSharp.gatsbyImageData.height,
        alt:
          post.featuredImage !== null && post.postFeaturedImageAltText !== undefined
            ? post.postFeaturedImageAltText.altText
            : defaultImg.heroImageDefaultAltText,
        createdAt: post.date,
        title: post.title,
        description: post.excerpt,
        link: `/blog${post.link}`,
      }
    }),
    blogCardStyles: {
      borderColor: 'border-orange-light',
      dateBgColor: 'bg-orange-light',
      dateColor: 'text-white',
      titleColor: 'text-black',
    },
    postsPerPage: data.wp.allSettings.readingSettingsPostsPerPage,
    outerBgColor: 'bg-white',
    arrowColor: '#F89422',
    paginationTextColor: 'text-orange-light',
  }
}

export function HomeHeroFunction(handleButton) {
  const { wpPage, wp } = useHomeHeroQuery()
  return {
    bgImage:
      wpPage.homeHero.homeHero.backgroundImage.localFile.childImageSharp.gatsbyImageData.images
        .fallback.src,
    bgImageMobile:
      wpPage.homeHero.homeHero.backgroundImageMobile.localFile.childImageSharp.gatsbyImageData
        .images.fallback.src,
    videoLink: wp.acfOptionsCommonItems.commonItems.playButton.videoLink.url,
    bgVideoLink: wpPage.homeHero.homeHero.backgroundVideo,
    bgGradient: 'bg-gradient-to-r from-[#0B171A] lg:via-transparent to-transparent',
    titleWhite1: wpPage.homeHero.homeHero.title.titleWhite1,
    titleOrange: wpPage.homeHero.homeHero.title.titleOrange,
    titleWhite2: wpPage.homeHero.homeHero.title.titleWhite2,
    subtitle: wpPage.homeHero.homeHero.text,
    buttonProps: {
      label: wp.acfOptionsCommonItems.commonItems.button2Text,
      notLink: true,
      borderColor: 'border-yellow',
      fontWeight: 'font-[900]',
      fontSize: 'text-[17px]',
      textColor: 'text-blue-dark2',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue-dark2',
      onClick: handleButton,
      icon: false,
    },
    textColor: 'text-white',
    textColor2: 'text-orange',
    heroBadge: wp.acfOptionsCommonItems.commonItems.heroBadge.localFile.publicURL,
    heroBadgeWidth: '373px',
    heroBadgeHeight: '163px',
    heroBadgeWidthMobile: '250px',
    heroBadgeHeightMobile: '109px',
    playButton: wp.acfOptionsCommonItems.commonItems.playButton.playButton.localFile.publicURL,
    playButtonText: wp.acfOptionsCommonItems.commonItems.playButton.videoLink.title,
    overlayImage: {
      src: wpPage.homeHero.homeHero.overlayImage.localFile.childImageSharp.gatsbyImageData.images
        .fallback.src,
      height:
        wpPage.homeHero.homeHero.overlayImage.localFile.childImageSharp.gatsbyImageData.height,
      width: wpPage.homeHero.homeHero.overlayImage.localFile.childImageSharp.gatsbyImageData.width,
    },
    overlayImageMobile: {
      src: wpPage.homeHero.homeHero.overlayImageMobile.localFile.childImageSharp.gatsbyImageData
        .images.fallback.src,
      height:
        wpPage.homeHero.homeHero.overlayImageMobile.localFile.childImageSharp.gatsbyImageData
          .height,
      width:
        wpPage.homeHero.homeHero.overlayImageMobile.localFile.childImageSharp.gatsbyImageData.width,
    },
  }
}

export function TestimonialsFunction() {
  const { wpPage, wp, reviewsSlider, forRatingValuePart1, forRatingValuePart2 } =
    useTestimonialsQuery()

  function length(obj) {
    return Object.keys(obj).length
  }

  const averageRating = useMemo(() => {
    const reviewsRatings = {
      reviewsForRatingValuePart1:
        forRatingValuePart1?.nodes.length &&
        forRatingValuePart1.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
      reviewsForRatingValuePart2:
        forRatingValuePart2?.nodes.length &&
        forRatingValuePart2.nodes.map((rating, i) => {
          return {
            index: i,
            rating: rating.rating,
          }
        }),
    }

    const fiveFourThreeRatings = length(reviewsRatings.reviewsForRatingValuePart2)

    const totalRatings = length(reviewsRatings.reviewsForRatingValuePart1)

    const ratingsTotal = reviewsRatings.reviewsForRatingValuePart1

    const total = ratingsTotal.reduce((sum, item) => sum + item.rating, 0)

    let avgRating = total / fiveFourThreeRatings
    avgRating = avgRating.toFixed(1)

    return [avgRating, totalRatings]
  }, [forRatingValuePart1, forRatingValuePart2])

  return {
    bgColor: 'bg-blue-dark3',
    titleOrange: wpPage.testimonials.testimonials.title.titleOrange,
    titleWhite: wpPage.testimonials.testimonials.title.titleWhite,
    subtitle1: wpPage.testimonials.testimonials.subtitle,
    subtitle2: wpPage.testimonials.testimonials.description,
    rate: averageRating[0],
    starPrimary: '#F79423',
    starSecondary: '#dddddd',
    reviewCnt: averageRating[1],
    reviewsLabel: wp.acfOptionsCommonItems.commonItems.reviewLabel,
    logoImg: wpPage.testimonials.testimonials.logo.localFile.publicURL,
    facebook: {
      logo: wpPage.testimonials.testimonials.reviewIcons.facebookIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.facebookIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    localReviews: {
      logo: wpPage.testimonials.testimonials.reviewIcons.localreviewsIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.localreviewsIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    angi: {
      logo: wpPage.testimonials.testimonials.reviewIcons.angiIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.angiIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    yahooLocal: {
      logo: wpPage.testimonials.testimonials.reviewIcons.yahooLocalIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.yahooLocalIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    merchantCircle: {
      logo: wpPage.testimonials.testimonials.reviewIcons.merchantCircleIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.merchantCircleIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    mapquest: {
      logo: wpPage.testimonials.testimonials.reviewIcons.mapquestIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.mapquestIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    google: {
      logo: wpPage.testimonials.testimonials.reviewIcons.googleIcon.localFile.publicURL,
      srcSet: wpPage.testimonials.testimonials.reviewIcons.googleIcon.localFile.publicURL,
      width: 55,
      height: 55,
    },
    testTextColor: '#0E3146',
    buttonProps: {
      label: wpPage.testimonials.testimonials.reviewsLink.title,
      notLink: false,
      borderColor: 'border-orange',
      fontWeight: 'font-[900]',
      fontSize: 'text-[17px]',
      textColor: 'text-white',
      bgColor: 'bg-orange',
      hoverBgColor: 'hover:bg-yellow',
      hoverBorderColor: 'hover:border-yellow',
      hoverTextColor: 'hover:text-white',
      href: wpPage.testimonials.testimonials.reviewsLink.url,
      icon: false,
    },
    titleColor1: 'text-white',
    titleColor2: 'text-orange',
    subtitleColor1: 'text-[#F5D34B]',
    subtitleColor2: 'text-white',
    textColor: 'text-white',
    cardBgColor: 'bg-white !h-full',
    overlayColor: 'bg-[#16394E]/[98%]',
    playButton: wpPage.testimonials.testimonials.playButton.localFile.publicURL,
    reviews: reviewsSlider.nodes.map(review => {
      return {
        rate: review.rating,
        firstName: review.reviewer.firstName,
        lastName: review.reviewer.lastName,
        logoImage: review.sourceType,
        content: review.comments,
      }
    }),
    videos: wpPage.testimonials.testimonials.videos.map(video => {
      return {
        videoLink: video.videoUrl,
        thumbnail: `${video.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src}`,
      }
    }),
    arrowBorderColor: 'border-white',
    arrowFillColor: '[&_path]:stroke-orange',
  }
}

export function WhatWeOfferFunction() {
  const data = useWhatWeOfferQuery()
  return {
    title: data.title,
    titleColor: 'text-[#0E3146]',
    tabs: data.offers.map(offer => {
      return {
        label: offer.label,
        title: offer.title,
        content: offer.description,
        buttonText: offer.link.title,
        href: offer.link.url,
        icon: offer.icon.localFile.publicURL,
        image: {
          src: offer.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
          alt: offer.altText,
          width: offer.image.localFile.childImageSharp.gatsbyImageData.width,
          height: offer.image.localFile.childImageSharp.gatsbyImageData.height,
        },
      }
    }),
    tabTitleActiveBorderColor: 'border-orange',
    tabTitleActiveTextColor: 'text-orange',
    tabTitleBorderColor: 'border-gray-light',
    tabTitleTextColor: 'text-[#0E3146]',
    tabTitleHoverBorderColor: 'hover:border-orange',
    tabTitleHoverTextColor: 'hover:text-orange',
    contentColor: 'text-[#0E3146]',
    bgColor: 'bg-gray-light',
    buttonProps: {
      notLink: false,
      borderColor: 'border-orange',
      fontWeight: 'font-[900]',
      fontSize: 'text-[17px]',
      textColor: 'text-white',
      bgColor: 'bg-orange',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:white',
      icon: false,
    },
  }
}

export function OurCouponsFunction() {
  const { wpPage, wp } = useOurCouponsQuery()
  return {
    title: wpPage.ourCoupons.coupons.title,
    titleColor: 'text-[#0E3146]',
    bgColor: 'bg-white',
    sliderProps: {
      isHome: true,
      coupons: wpPage.ourCoupons.coupons.coupons.map(coupon => {
        return {
          couponDescription: coupon.text,
          percentageOrFixedAmount: coupon.percentOrFixedAmount,
          amountOff: coupon.amount,
          showOff: coupon.showOff,
        }
      }),
      couponProps: {
        logo: {
          src: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
          srcSet: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
        },
        bgColor: 'bg-blue',
        textColorTop: 'text-yellow',
        textColorBottom: 'text-white',
        printText: wpPage.ourCoupons.coupons.printButtonText,
        disclaimer: wpPage.ourCoupons.coupons.couponDisclaimer,
        offColor: 'text-white',
        priceBorder: 'border-white',
        priceBgColor: 'bg-orange',
        fillColor: 'fill-white',
        printColor: 'text-white',
        bgColorSecondary: 'bg-orange',
        textColorTopSecondary: 'text-white',
        priceBgColorSecondary: 'bg-blue',
        printColorSecondary: 'text-blue',
      },
      buttonPropsHome: {
        label: wpPage.ourCoupons.coupons.linkTextHome,
        notLink: false,
        borderColor: 'border-yellow',
        fontWeight: 'font-[900]',
        fontSize: 'text-[17px]',
        textColor: 'text-blue-dark2',
        bgColor: 'bg-yellow',
        hoverBgColor: 'hover:bg-yellow-lighter',
        hoverBorderColor: 'hover:border-yellow-lighter',
        hoverTextColor: 'hover:text-blue-dark2',
        href: wpPage.ourCoupons.coupons.linkUrl,
        icon: false,
      },
    },
  }
}

export function AccoladesFunction() {
  const data = useAccoladesQuery()
  return {
    title: data.title,
    subtitle: data.subtitle,
    accolades: data.accolades.map(accolade => {
      return {
        image: accolade.image.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
        srcSet: accolade.image.localFile.childImageSharp.gatsbyImageData.images.fallback.srcSet,
        width: accolade.image.localFile.childImageSharp.gatsbyImageData.width,
        height: accolade.image.localFile.childImageSharp.gatsbyImageData.height,
        altText: accolade.altText,
        label: accolade.label,
      }
    }),
    titleColor: 'text-blue-dark2',
    textColor: 'text-blue-dark2',
    bgColor: 'bg-white',
    activeImg: data.activeOverlay.localFile.publicURL,
  }
}
export function OurStoryFunction() {
  const { wpPage, wp } = useOurStoryQuery()
  const story = wpPage.ourStory.ourStory
  return {
    thirtyYears: {
      src: story.yearsInBusinessImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      alt: story.yearsInBusinessAltText,
      width: story.yearsInBusinessImage.localFile.childImageSharp.gatsbyImageData.width,
      height: story.yearsInBusinessImage.localFile.childImageSharp.gatsbyImageData.height,
    },
    title: story.title,
    subtitle: story.subtitle,
    text: story.text,
    largerText: story.largerText,
    link: {
      label: story.link.title,
      notLink: false,
      borderColor: 'border-yellow',
      fontWeight: 'font-[900]',
      fontSize: 'text-[17px]',
      textColor: 'text-blue-dark2',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue-dark2',
      href: story.link.url,
      icon: false,
    },
    bgImg: story.teamBackgroundImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
    playButton: (
      <ReactSVG
        src={wp.acfOptionsCommonItems.commonItems.playButton.playButton.localFile.publicURL}
      />
    ),
    videoText: wp.acfOptionsCommonItems.commonItems.playButton.videoLink.title,
    videoTextColor: 'text-white',
    truck: {
      src: story.truckImage.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
      alt: story.truckAltText,
      width: story.truckImage.localFile.childImageSharp.gatsbyImageData.width,
      height: story.truckImage.localFile.childImageSharp.gatsbyImageData.height,
    },
    titleColor: 'text-yellow',
    textColor: 'text-blue-dark3',
    videoUrl: wp.acfOptionsCommonItems.commonItems.playButton.videoLink.url,
    overlayColor: 'bg-black/40',
    thirtyYearsBgColor: 'bg-white',
    bgColor: 'bg-white',
  }
}
export function OurServicesFunction(handleButton) {
  const { wpPage, wp } = useOurServicesQuery()
  const services = wpPage.ourServices.ourServices
  return {
    bgColor: 'bg-blue-dark',
    textColor: 'text-blue-lightest',
    titleColor: 'text-white',
    borderColor: 'border-blue-lightest',
    activeBorderColor: 'border-orange',
    title: services.title,
    serviceCategories: services.services.map(service => {
      return {
        icon: <ReactSVG src={service.icon.localFile.publicURL} />,
        label: service.label,
        title: service.title,
        text: service.text,
        services: service.tabServices.map(tabService => {
          return {
            icon: <ReactSVG src={tabService.icon.localFile.publicURL} />,
            label: tabService.label,
            image: {
              src: tabService.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
              alt: tabService.altText,
              width: tabService.image.localFile.childImageSharp.gatsbyImageData.width,
              height: tabService.image.localFile.childImageSharp.gatsbyImageData.height,
            },
            title: tabService.title,
            text: tabService.text,
            link: {
              url: tabService.link.url,
              text: tabService.link.title,
            },
          }
        }),
      }
    }),
    activeCategoryIconColor: '[&_path]:fill-white',
    buttonHover:
      '[&_path]:hover:fill-yellow-lighter hover:text-yellow-lighter [&_.ourServicesArrow]:hover:rotate-90',
    buttonActive:
      'border-transparent [&_path]:fill-yellow-lighter text-yellow-lighter [&_.ourServicesArrow]:rotate-90',
    buttonActiveDesktop: '[&_path]:fill-yellow-lighter text-yellow-lighter',
    arrowActiveColor: '[&_path]:fill-yellow-lighter',
    callButton: {
      label: `${wp.acfOptionsCommonItems.commonItems.callText} ${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      notLink: false,
      fontSize: 'text-lg',
      textColor: 'text-blue-dark2',
      borderColor: 'border-yellow',
      bgColor: 'bg-yellow',
      hoverBgColor: 'hover:bg-yellow-lighter',
      hoverBorderColor: 'hover:border-yellow-lighter',
      hoverTextColor: 'hover:text-blue-dark2',
      href: `tel:${wp.acfOptionsCommonItems.commonItems.phoneNumber}`,
      icon: true,
      iconColor: '#0D3045',
      phoneOrCalender: 'phone',
    },
    estimateButton: {
      label: wp.acfOptionsCommonItems.commonItems.button2Text,
      notLink: true,
      borderColor: 'border-orange-light',
      fontSize: 'text-lg',
      textColor: 'text-white',
      bgColor: 'bg-orange-light',
      hoverBgColor: 'hover:bg-orange-dark',
      hoverBorderColor: 'hover:border-orange-dark',
      hoverTextColor: 'hover:text-white',
      onClick: handleButton,
      icon: false,
    },
    learnMoreButtonColor:
      'border-white text-white hover:border-yellow-light hover:text-yellow-light',
    selectEven: 'border-r-yellow-light',
    selectOdd: 'border-l-yellow-light',
  }
}
export function OurWorkFunction() {
  const data = useOurWorkQuery()
  return {
    title: data.title,
    bgColor: 'bg-gray-lighter',
    titleAndCategoryColor: 'text-blue-dark3',
    townNameColor: '!text-orange-dark',
    jobColor: '!text-white',
    gradientColor: 'from-black',
    arrowBgColor: 'bg-orange',
    borderColor: 'border-orange',
    photos: data.categories.map(category => {
      return {
        category: category.categoryLabel,
        link: {
          label: category.link.title,
          borderColor: 'border-yellow',
          fontWeight: 'font-[900]',
          fontSize: 'text-[17px]',
          textColor: 'text-blue-dark2',
          bgColor: 'bg-yellow',
          hoverBgColor: 'hover:bg-yellow-lighter',
          hoverBorderColor: 'hover:border-yellow-lighter',
          hoverTextColor: 'hover:text-blue-dark2',
          href: category.link.url,
        },
        categoryPhotos: category.images.map(image => {
          return {
            townName: image.townName,
            job: image.job,
            photo: {
              src: image.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src,
              width: image.image.localFile.childImageSharp.gatsbyImageData.width,
              height: image.image.localFile.childImageSharp.gatsbyImageData.height,
              alt: image.altText,
            },
          }
        }),
      }
    }),
  }
}
export function CouponFunction(coupon) {
  const { wpPage, wp } = useOurCouponsQuery()
  return {
    couponDescription: coupon.text,
    logo: {
      src: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
      srcSet: wp.acfOptionsCommonItems.commonItems.logo.localFile.publicURL,
    },
    bgColor: 'bg-blue',
    textColorTop: 'text-yellow',
    textColorBottom: 'text-white',
    percentageOrFixedAmount: coupon.percentOrFixedAmount,
    amountOff: coupon.amount,
    printText: wpPage.ourCoupons.coupons.printButtonText,
    disclaimer: wpPage.ourCoupons.coupons.couponDisclaimer,
    offColor: '!text-white',
    priceBorder: 'border-white',
    priceBgColor: 'bg-orange',
    showOff: coupon.showOff,
    fillColor: 'fill-white',
    printColor: 'text-white',
    primary: true,
  }
}
export function CouponDescriptionFunction(coupon) {
  return {
    bgColor: 'bg-transparent',
    borderColor: 'border-blue-dark3',
    description: coupon.description,
    textColor: 'text-black',
  }
}
export function MobileCTABarFunction(handleButton) {
  const { wp, wpPage } = useMobileCtaQuery()
  const { ctas } = wpPage.ctaBar.ctaBar

  return {
    textColor: 'text-white',
    bgColor: 'bg-blue-dark3',
    buttonOnClick: handleButton,
    phone: {
      icon: <ReactSVG src={ctas[0].icon.localFile.publicURL} />,
      number: wp.acfOptionsCommonItems.commonItems.phoneNumber,
      bgColor: 'bg-orange',
      fill: '[&_path]:fill-orange [&_rect]:fill-orange',
      text: ctas[0].buttonText,
    },
    service: {
      icon: <ReactSVG src={ctas[1].icon.localFile.publicURL} />,
      bgColor: 'bg-orange',
      fill: '[&_circle]:fill-orange',
      borderColor: 'border-transparent',
      text: ctas[1].buttonText,
      padding: 'p-0',
    },
    coupon: {
      link: ctas[2].link.url,
      icon: <ReactSVG src={ctas[2].icon.localFile.publicURL} />,
      bgColor: 'bg-orange',
      fill: '[&_rect]:fill-orange',
      text: ctas[2].link.title,
    },
  }
}

export function DataPinsFunction(data) {
  const serviceAreas = useServiceAreasQuery()
  const { wp, site } = useDataPinsQuery()

  return {
    mapApiKey: `${process.env.GATSBY_MAP_API_KEY}`,
    weatherWidget: data.wpPage.dataPins.dataPins.weatherWidget,
    mapCenter: {
      lat: parseFloat(data.wpPage.dataPins.dataPins.mapCenter.latitude),
      lng: parseFloat(data.wpPage.dataPins.dataPins.mapCenter.longitude),
    },
    mapZoom: 11,
    locationData: data.wpPage.dataPins.dataPins.cards.map(card => {
      return {
        name: card.name,
        date: card.date,
        content: card.description,
        image:
          card.image.localFile.childImageSharp.gatsbyImageData !== null
            ? card.image.localFile.childImageSharp.gatsbyImageData.images.fallback.src
            : wp.acfOptionsCommonItems.commonItems.dataPins.defaultCardImage.localFile
                .childImageSharp.gatsbyImageData.images.fallback.src,
      }
    }),
    title: wp.acfOptionsCommonItems.commonItems.dataPins.cardsTitle,
    cardBorderColor: 'border-gray-lighter',
    borderColor: 'border-orange',
    descriptionBgColor: 'bg-gray-lighter',
    quoteSvg: wp.acfOptionsCommonItems.commonItems.dataPins.quoteSvg.localFile.publicURL,
    buttonProps: {
      rounded: false,
      hasArrow: true,
      notLink: true,
      label: 'View More',
      bgColor: 'bg-blue',
      fontSize: 'text-[1.125rem] md:text-[1.5rem]',
      textColor: 'text-white',
      hoverBg: 'hover:bg-blue-dark',
      hoverTextColor: 'hover:text-white',
    },
    pinColor: '[&_path]:fill-red',
    serviceAreas: serviceAreas.countiesAndTowns.map(county => {
      return {
        county: county.county,
        towns: county.towns,
      }
    }),
    serviceAreasBgColor: 'bg-blue',
    serviceAreasTextColor: 'text-white',
    serviceAreasTitle: wp.acfOptionsCommonItems.commonItems.dataPins.serviceAreasTitle,
    iconFillColor: '[&_path]:fill-white',
    townBgColor: 'bg-white',
    serviceAreasHoverBgColor: 'hover:bg-orange',
    activeBgColor: '!bg-orange',
    schemaData: {
      type: wp.nexvelSchemaMarkup.nexvelschema.businessType,
      name: wp.nexvelSchemaMarkup.nexvelschema.businessName,
      url: site.siteMetadata.siteUrl,
      sameAs: wp.acfOptionsCommonItems.commonItems.footer.socialMedia.map(social => {
        return {
          url: social.socialMediaLink.url,
        }
      }),
    },
  }
}
